// import React from "react";
// import { BrowserRouter, useLocation } from "react-router-dom";
// import Navigation from "../src/Navigation/Navigation";
// import Footer from "./Component/Footer/Footer";
// import { store } from "./Component/redux/store";
// import { Provider } from "react-redux";

// const AppContent = () => {
//   const location = useLocation();
//   const hideFooterRoutes = ["/"];
//   const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

//   return (
//     <>
//       <Provider store={store}>
//         <Navigation />
//         {!shouldHideFooter && <Footer />}
//       </Provider>
//     </>
//   );
// };

// const App = () => {
//   return (
//     <BrowserRouter>
//       <AppContent />
//     </BrowserRouter>
//   );
// };

// export default App;

import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Navigation from "../src/Navigation/Navigation";
import Footer from "./Component/Footer/Footer";
import { store } from "./Component/redux/store";
import { Provider } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { environment } from "./environments/environments";

const stripePromise = loadStripe(environment.stripe_id);

const AppContent = () => {
  const location = useLocation();
  const hideFooterRoutes = ["/"];
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <Provider store={store}>
      <Navigation />
      {!shouldHideFooter && <Footer />}
    </Provider>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Elements stripe={stripePromise}>
        <AppContent />
      </Elements>
    </BrowserRouter>
  );
};

export default App;
